import { render } from "./UiDateRangePicker.vue?vue&type=template&id=4d5fd55b&ts=true"
import script from "./UiDateRangePicker.vue?vue&type=script&lang=ts"
export * from "./UiDateRangePicker.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__